import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpHeaders
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppService } from '@core/services/app/app.service';
import { Observable } from 'rxjs';

export interface ReqErrorConfigModel {
  showError: boolean;
  defaultMessage: string;
}

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {
  constructor(private appService: AppService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const authReq = req.clone({
      headers: this.addHeaders(req)
    });

    return next.handle(authReq);
  }

  private addHeaders(req: HttpRequest<any>): HttpHeaders {
    let headers =
      req.headers instanceof HttpHeaders ? req.headers : new HttpHeaders();

    headers = headers
      .set('pragma', 'no-cache')
      .set('Cache-Control', 'no-cache')
      .set('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT');

    const demoDatasetId = this.appService.getEnvironment().demoDatasetId;

    if (demoDatasetId) {
      headers = headers.set('Raven-Dataset-Id', demoDatasetId);
    }

    return headers;
  }
}
